import { IconWrapper } from "@insite/mobius/Icon";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import ChevronLeft from "@store/Components/Icons/ChevronLeft";
import ChevronRight from "@store/Components/Icons/ChevronRight";
import { TYPOGRAPHY } from "@store/theme/design";
import { buttonResetStyles, contentSpacingStyles, scalableIconStyles } from "@store/theme/mixins";
import { polyfillCss } from "@store/theme/polyfills";
import { css } from "styled-components";

const itemSize = "28px";
const horizontalSpacing = "0.2em";

export default {
    defaultProps: {
        cssOverrides: {
            pagination: polyfillCss`
                justify-content: center;
					${({ theme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    ${contentSpacingStyles(TYPOGRAPHY.spacing.base, TYPOGRAPHY.spacing.base)}
                                `,
                                null,
                                null,
                                css`
                                    ${contentSpacingStyles(TYPOGRAPHY.spacing.large, TYPOGRAPHY.spacing.large)}
                                `,
                                null,
                            ],
                            mediaOptions.min,
                        )}
            `,
            currentButton: polyfillCss`
                background-color: ${getColor("primary")};
                color: ${getColor("primary.contrast")};
            `,
            ellipsis: polyfillCss`
				width: ${itemSize};
				line-height: 0;
                margin: -.4em ${horizontalSpacing} 0;
                cursor: default;
				color: ${getColor("primary")};
				font-size: 1.5em;
				font-weight: 900;
				text-align: center;
            `,
            linkList: polyfillCss`
                margin: 0 !important;

                ul {
                    display: flex;
                    align-items: center;
                    
                    li {
                        margin: 0 ${horizontalSpacing};

                        &:first-child, &:last-child {
                            display: none;
                        }
                    }
                }
            `,
            perPageSelect: css`
                display: none !important;
            `,
        },
        buttonProps: {
            typographyProps: {
                size: TYPOGRAPHY.size.smaller,
                weight: TYPOGRAPHY.weight.black,
                lineHeight: TYPOGRAPHY.lineHeight.small,
            },
            css: css`
                ${buttonResetStyles()}
                display: flex;
                align-items: center;
                justify-content: center;
                width: auto;
                min-width: ${itemSize};
                height: ${itemSize};
                margin: 0;
                padding: 0 0.5em;

                ${IconWrapper} {
                    ${scalableIconStyles("2.4em")}
                }

                &:disabled {
                    cursor: default;
                }

                &:not(:disabled) {
                    ${IconWrapper} {
                        color: ${getColor("primary")};
                    }

                    &:hover {
                        ${IconWrapper} {
                            color: ${getColor("primary.dark")};
                        }
                    }
                }
            `,
        },
        navIconsSrc: {
            previousPage: ChevronLeft,
            nextPage: ChevronRight,
        },
    },
};
